const roles = {
  //the elevated permission role we must match
  ADMIN: 'admin',
  USER: 'user',
};

export default roles;
